import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'

const base = 'companies'

AdminRouter.addRoute({
  name: `${base}`,
  path: `/${base}`,
  component: () => import('./Index.vue'),
  meta: {
    auth: true,
  },
})
AdminRouter.addRoute({
  name: `${base}.my_commissions`,
  path: `/${base}/my-commissions`,
  component: () => import('./MyCommissions.vue'),
  meta: {
    auth: true,
  },
})
AdminRouter.addRoute({
  name: `${base}.create`,
  path: `/${base}/create`,
  component: () => import('./Create.vue'),
  meta: {
    auth: true,
  },
})
AdminRouter.addRoute({
  name: `${base}.edit`,
  path: `/${base}/:id`,
  component: () => import('./Edit.vue'),
  meta: {
    auth: true,
  },
})
AdminRouter.addRoute({
  name: `${base}.commissions`,
  path: `/${base}/:id/commissions`,
  component: () => import('./Commissions.vue'),
  meta: {
    auth: true,
  },
})

AdminSidebar.pushItem({
  id: `${base}`,
  order: 20,
  header: $vm => $vm.$t(`general.menu_management`),
  text($vm) {
    return $vm.$t(`${base}.title`)
  },
  route: {
    name: `${base}`,
  },
  icon: 'icon-office',
  permission: 'companies.index',
})

messageGroups.push(base)
